import React, { useEffect, useState } from "react";
import "./placeOrder.css";
import { TiUser } from "react-icons/ti";
import {
  HiOutlineMail,
  HiOutlineReceiptTax,
  HiCash,
  HiOutlineCreditCard,
} from "react-icons/hi";
import { BiPhone, BiMapPin, BiMessageSquareEdit } from "react-icons/bi";
import { FaRegAddressCard } from "react-icons/fa";
import { getUserInfo } from "../../actions/userActions";
import { getCartbyUser } from "../../actions/cartAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RingLoader } from "../../components";
import { Button } from "@mui/material";
import Cookies from "universal-cookie";
import { Link } from "react-router-dom";
import { placeUserOrders } from "../../actions/orderActions";
import { toast } from "react-toastify";
import api from "../../utils/axiosInstance";
import {
  createPaymentOrder as createPaymentOrderRoute,
  verifyPayment as verifyPaymentRoute,
} from "../../constant/routes";

const PlaceOrder = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalAmount, setTotalAmount] = useState(0);
  const [processing, setProcessing] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('cod'); // 'cod' | 'online'
  const userState = useSelector((state) => state.userLogin);
  const userCart = useSelector((state) => state.cart);
  const cookies = new Cookies();
  let tkn = cookies.get("tkn");

  const calculateTotal = () => {
    let value = 0;
    for (let i = 0; i < userCart.cart.length; i++) {
      value =
        value + userCart.cart[i].productPrice * userCart.cart[i].quanitity;
    }
    setTotalAmount(value);
  };

  const buildOrderData = (paymentId = null) => {
    const id = cookies.get("ui");
    return {
      items: userCart.cart,
      paymentMethod: paymentMethod === 'cod' ? "Cash on Delivery" : "Online Payment",
      paymentId,
      userInfo: {
        userName: userState.userInfo.name,
        userEmail: userState.userInfo.email,
        phone: {
          phoneNumber: userState.userInfo.phoneNumber,
          secondaryPhoneNumber: userState.userInfo.secondaryPhoneNumber,
        },
        address: {
          city: userState.userInfo.city,
          state: userState.userInfo.state,
          landmark: userState.userInfo.landmark,
          house_flat_no: userState.userInfo.house_flat_no,
          pincode: userState.userInfo.pincode,
          address: userState.userInfo.address,
        },
      },
      userId: id,
    };
  };

  const handlePayment = async () => {
    if (userCart.cart.length === 0) {
      toast.error("You don't have any item in your cart");
      return;
    }

    setProcessing(true);

    // Cash on Delivery — place order directly
    if (paymentMethod === 'cod') {
      dispatch(placeUserOrders(buildOrderData(), navigate));
      return;
    }

    // Online Payment via Razorpay
    // Step 1 — create Razorpay order on backend
    const orderRes = await api
      .post(createPaymentOrderRoute, { amount: totalAmount * 100 })
      .then((r) => r)
      .catch((err) => err);

    if (orderRes.status !== 200) {
      toast.error("Failed to initiate payment. Please try again.");
      setProcessing(false);
      return;
    }

    // Step 2 — open Razorpay checkout modal
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: totalAmount * 100,
      currency: "INR",
      name: "E-Way",
      description: "Order Payment",
      order_id: orderRes.data.id,

      // Step 3 — on successful payment
      handler: async (response) => {
        const verifyRes = await api
          .post(verifyPaymentRoute, {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          })
          .then((r) => r)
          .catch((err) => err);

        if (verifyRes.status === 200 && verifyRes.data.success) {
          dispatch(
            placeUserOrders(buildOrderData(verifyRes.data.paymentId), navigate)
          );
        } else {
          toast.error("Payment verification failed. Please contact support.");
          setProcessing(false);
        }
      },

      prefill: {
        name: userState.userInfo.name,
        email: userState.userInfo.email,
        contact: userState.userInfo.phoneNumber,
      },
      theme: { color: "#61ce70" },
      modal: {
        ondismiss: () => {
          toast.info("Payment cancelled");
          setProcessing(false);
        },
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  useEffect(() => {
    if (userState.userInfo.name === undefined) {
      dispatch(getUserInfo());
    }
    calculateTotal();
  }, [userState, userCart]); // eslint-disable-line

  useEffect(() => {
    if (tkn !== undefined) {
      dispatch(getCartbyUser("getCartbyUser"));
    }
  }, []); // eslint-disable-line

  useEffect(() => {
    window.scrollTo(0, 0);
  }); // eslint-disable-line

  return (
    <>
      {userState.userInfo.name !== undefined && userCart.fetching !== true ? (
        <div className="placeOrderPage">
          <div className="placeOrderPageInfo">
            {/* user Items */}
            <div className="userItems">
              <h1>
                Your Items{" "}
                <Link to={"/mycart"}>
                  <button>
                    EDIT <BiMessageSquareEdit />
                  </button>
                </Link>
              </h1>
              {userCart.cart.length > 0 ? (
                <div className="orderProductContainer">
                  {userCart.cart.map((item, index) => {
                    return (
                      <div key={index} className="orderProduct">
                        <img src={item.primaryImg} alt={item.name} />
                        <h4>{item.name}</h4>
                        <p>
                          ₹ {item.productPrice}
                          <span>qnt. x {item.quanitity}</span>
                        </p>
                      </div>
                    );
                  })}
                </div>
              ) : (
                "No item"
              )}
            </div>

            {/* user info */}
            <div className="userInfo">
              <h1>Your details</h1>
              <div className="userInfoContainer">
                {/* personal info */}
                <div className="card">
                  <h4>Name and phone</h4>
                  <span className="cardInfo">
                    <TiUser />
                    <p>{userState.userInfo.name}</p>
                  </span>
                  <span className="cardInfo">
                    <HiOutlineMail />
                    <p>{userState.userInfo.email}</p>
                  </span>
                  <span className="cardInfo">
                    <BiPhone />
                    <p>
                      <>{userState.userInfo.phoneNumber}</>
                      {userState.userInfo.secondaryPhoneNumber !== null ? (
                        <>, {userState.userInfo.secondaryPhoneNumber}</>
                      ) : (
                        ""
                      )}
                    </p>
                  </span>
                </div>

                {/* address info */}
                <div className="card">
                  <h4>
                    Shipping Address{" "}
                    <Link to={"/myprofile"}>
                      <button>
                        EDIT <BiMessageSquareEdit />
                      </button>
                    </Link>
                  </h4>
                  <span className="cardInfo">
                    <FaRegAddressCard />
                    <p>
                      {userState.userInfo.city}, {userState.userInfo.state}{" "}
                      <br />
                      {userState.userInfo.landmark},{" "}
                      {userState.userInfo.house_flat_no} <br />
                      {userState.userInfo.address}
                    </p>
                  </span>
                  <span className="cardInfo">
                    <BiMapPin />
                    <p>{userState.userInfo.pincode}</p>
                  </span>
                </div>

                {/* Payment summary */}
                <div className="card">
                  <h4>Payment Summary</h4>
                  <span className="cardInfo" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '0.5rem' }}>
                    <p style={{ margin: 0 }}>Payment Method :</p>
                    <div style={{ display: 'flex', gap: '1rem' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                        <input
                          type="radio"
                          name="paymentMethod"
                          value="cod"
                          checked={paymentMethod === 'cod'}
                          onChange={() => setPaymentMethod('cod')}
                        />
                        <HiCash /> Cash on Delivery
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                        <input
                          type="radio"
                          name="paymentMethod"
                          value="online"
                          checked={paymentMethod === 'online'}
                          onChange={() => setPaymentMethod('online')}
                        />
                        <HiOutlineCreditCard /> Online (Razorpay)
                      </label>
                    </div>
                  </span>
                  <span className="cardInfo">
                    <HiCash />
                    <p>
                      Sub total : <span>₹ {totalAmount}</span>
                    </p>
                  </span>
                  <span className="cardInfo">
                    <HiOutlineReceiptTax />
                    <p>
                      Taxes : <span>Free</span>
                    </p>
                  </span>
                  <span className="cardInfo">
                    <p>
                      <span></span>
                      <strong>Total : ₹ {totalAmount}</strong>
                    </p>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="confirmOrder">
            <Button onClick={handlePayment} disabled={processing}>
              {processing
                ? "Processing..."
                : paymentMethod === 'cod'
                  ? "Place Order (Cash on Delivery)"
                  : "Proceed to Pay ₹ " + totalAmount}
            </Button>
          </div>
        </div>
      ) : (
        <RingLoader />
      )}
    </>
  );
};

export default PlaceOrder;
